import { NavigationGuardNext } from 'vue-router'
import { store } from '../store'

const xeroGuard = (to, from , next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (reason = '') => {
        store.getters.appDebug && console.log(`GUARD: xero-guard pass (${reason})`)
        return next()
    }

    //  Create a 'fail' function
    const fail = (reason = '') => {
        store.getters.appDebug && console.log(`GUARD: xero-guard fail (${reason})`)
        return next('/home')
    }

    //  Get the current tenant
    const tenant = store.getters.tenant

    //  If the tenant does NOT exist, guard fails
    if (!tenant) return fail('no tenant')

    //  If the tenant does NOT has a data provider, guard passes
    if (!tenant.data_provider) return pass('no data provider')

    //  IF the tenant data provider is XERO, gaurd passes
    if (tenant.data_provider === 'XERO') {
        //  Set xero connection status
        store.dispatch('xeroConnection')
        
        return pass('provider is xero')
    }

    //  Else, guard fails
    return fail('data provider is NOT xero')
}

export default xeroGuard
